import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import queryString from 'query-string'
import { withRouter } from 'react-router-dom'
import featuresPlugin from '@blazar-plugins/features'
import List from '../List'
import RealList from './List'

const mapStateToProps = (state) => ({
  featureFlag: featuresPlugin.selectors.isEnabled(state, 'bostad-landing-page-experiment'),
})

const ListRealEstate = ({ location, featureFlag }) => {
  const queryParams = queryString.parse(location.search)

  if (queryParams.cg === '3000' && featureFlag && !queryParams.st) {
    return <RealList />
  }

  return <List />
}

ListRealEstate.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }).isRequired,
  featureFlag: PropTypes.bool,
}

export default withRouter(connect(mapStateToProps)(ListRealEstate))
